import {mapState, mapGetters, mapActions} from 'vuex';
// import {getByIds} from '@/functions/src/repository/Generic';

// import * as functions from 'firebase-functions';
// import {config} from '../config';

// import * as admin from 'firebase-admin';

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    currentCompany: (state) => state.currentCompany,
    currentCompanyId: (state) => state.currentCompanyId,
    currentCompanyMatriz: (state) => state.currentCompanyMatriz,
    currentCompanyMatrizId: (state) => state.currentCompanyMatrizId,
    isSuperAdminAccess: (state) => state.isSuperAdminAccess,
    companyId: (state) => state.companyId,
    currentWorkspace: (state) => state.currentWorkspace,
    systemNeedReload: (state) => state.systemNeedReload,
  }),
  ...mapGetters('auth', ['loggedIn', 'getterIsResident']),
};
export const cacheComputed = {
  ...mapState('caches', {
    cacheHospitals: (state) => state.hospitals,
    cacheHealthInsurances: (state) => state.healthInsurances,
    cacheUsers: (state) => state.users,
    cacheFiliais: (state) => state.filiais,
    cacheAdminCompanies: (state) => state.adminCompanies,
    cacheChartOfAccounts: (state) => state.chartOfAccounts,

    hospitalsKey: (state) => state.hospitalsKey,
    healthInsurancesKey: (state) => state.healthInsurancesKey,
    usersKey: (state) => state.usersKey,
    filiaisKey: (state) => state.filiaisKey,
    adminCompaniesKey: (state) => state.adminCompaniesKey,
    chartOfAccountsKey: (state) => state.chartOfAccountsKey,

    // cacheScrubNurse: (state) => state.users.filter(a=>{
    //   return a._companyUser.active && a._companyUser.type===UserType.SCRUB_NURSE;
    // }),
  }),
  ...mapGetters('caches', ['getterActiveScrubNurses', 'getterActiveAnesthetists', 'getterActiveSurgeons',
    'getterActiveResidentAnesthetist', 'getterActiveAdminCompanies', 'getterActiveUsers', 'getterActiveFiliais',
    'getterAnesthetists', 'getterSurgeons', 'getterResidentAnesthetist', 'getterActiveHospitals',
    'getterActiveHealthInsurances', 'getterActivePhonoaudiologist', 'getterPhonoaudiologist',
    'getterActiveChartOfAccounts']),
};

export const cacheMethods = mapActions('caches', ['tryInitProcedures']);

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'modelCompanyUpdate', 'listCompanies',
  'onAuthStateChanged', 'getAdminMailByFakeMail', 'modelClientUpdate', 'modelAdminUpdate', 'modelCompanyUserUpdate',
  'logInSocial', 'startLogin', 'endLogin', 'logInPhone', 'logInClient', 'companyChangeOpen',
  'ongRegister', 'modelOngUpdate', 'listOngs', 'modelOngUserUpdate', 'loadCompanyOnClient', 'loadCompanyOnAdmin',
  'authCompanyModulesValidate', 'authCompanyModulesValidateMultiple', 'onlySignInWithEmailAndPassword',
  'updatePassword']);

export const configComputed = {
  ...mapState('config', {
    configConfigWeb: (state) => state.configWeb,
    configIsOnline: (state) => state.isOnline,
  }),
};
